import { PAGE_LEVEL } from '@/constants';

/**
 * 工作台模块路由
 */
export default {
  path: '/workbench',
  children: [
    {
      path: 'index',
      name: 'workbenchIndex',
      component: () => import('@/pages/workbench/index.vue'),
      meta: {
        componentName: 'WorkbenchIndex',
        pageLevel: PAGE_LEVEL.FIRST,
        name: 'common.noun.workbench',
        keepAlive: true
      }
    }
  ]
};
